export const AVAILABLE_PAGING_SIZES = [25, 50, 100]

export const PAGING_SIZE_COOKIE_NAME = 'page_size'

export const DEFAULT_PAGE_SIZE = AVAILABLE_PAGING_SIZES[0]

export const generatePagingItems = (currentPage, totalPages) => {
  if (totalPages < 5) {
    return [...Array(totalPages).keys()].map((number) => ({
      label: number + 1,
      pageNumber: number + 1,
    }))
  }

  const pages = []

  const addPage = (label, pageNumber = label) => {
    pages.push({ label, pageNumber })
  }

  addPage(1)

  if (currentPage > 3) {
    addPage('...', false)
  }

  if (currentPage >= totalPages) {
    addPage(totalPages - 2)
  }

  const start = Math.max(2, currentPage - 1)
  const end = Math.min(totalPages - 1, currentPage + 1)

  for (let i = start; i <= end; i++) {
    addPage(i)
  }

  if (currentPage === 1) {
    addPage(3)
  }

  if (currentPage <= totalPages - 3) {
    addPage('...', false)
  }

  addPage(totalPages)

  return pages
}
